<template>
    <div style="background: #F9FAFB; display: flex; flex-direction: column; width: 100%;  align-items: stretch; height: 100%; ">
        <hb-blade-header
            :title="template_title"
            show-help-link
            back-button-off
            :left-align-title="true"
            :first-column-off="true"
            background="white"
            @close="cancelSave"
        >

            <template v-slot:right  v-if="template_is_loaded">
                
                <hb-tooltip dashed class="mr-2" >
                    <template v-slot:item  >
                        {{ template.Properties.length}} Properties
                    </template>
                    <template v-slot:header>
                        Properties
                    </template>
                    <template v-slot:body>
                        <div v-for="p in template.Properties" :key="p.id">
                            <div>{{ getProperty(p).number }} {{ getProperty(p).name }}</div>
                        </div>
                    </template>
                </hb-tooltip>
 
                <v-menu
                    
                    close-on-click
                    close-on-content-click
                    offset-y
                    class="d-inline-block"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" class="d-inline-block">
                        <hb-btn icon active-state-off>
                            mdi-dots-vertical
                        </hb-btn>
                    </span>
                    </template>
                    <v-list class="menu-list other-document-actions">
                    <v-list-item :ripple="false" class="menu-list-item" @click="showEditForm = true" v-if="hasPermission('edit_template')" >
                        Edit
                    </v-list-item>
                    
                    </v-list>
                </v-menu>

     
            </template>

        </hb-blade-header>

        <div class="manage-template-container" style="display: flex; width: 100%; height: 100%; align-items: stretch; height: 100%; flex: 1 0; background-color: #F9FAFB">
            <div style="flex: 1 0; display: flex; flex-direction: column;">
                
                
                <div style="flex: 1 0;" v-if="template_is_loaded">
        
                    <Editor ref="editor" :is_closing="is_closing" :template="template.template" :template_header="template.template_header"  :template_footer="template.template_footer" document_type="document" @showPreview="showPreview" @showMergeFields="showMergeFields"/>

                    
                </div>
                <div v-else-if="template_is_loading" style="text-align: center; padding-top: 50px;">
                    <v-progress-circular
                        indeterminate
                        size="24" 
                        width="2"
                        color="primary"
                    ></v-progress-circular>
                </div>
            </div>

            
            
             <div v-if="panel" style="flex: 0 1 360px; display: flex; flex-direction: column; position: absolute; right: 0; border-left: 1px solid #e2e2e2 ">
                <MergeFields v-if="panel == 'merge_fields'" @addMergeField="addMergeField" @closeMergeFields="closeMergeFields" />   
            </div>
           



        </div>
        <HbBottomActionBar @close="cancelSave">
            <template v-slot:left-actions>
                <hb-btn
                    icon
                    tooltip="Click Here to Learn More About Our New Document Manager"
                    @click="getHelpLink"
                >
                    mdi-help-circle-outline
                </hb-btn>
                <hb-link
                    class="ml-n2"
                    @click="getHelpLink"
                >
                    Click Here to Learn More About Our New Document Manager
                </hb-link>
            </template>
             <template v-slot:right-actions>
                <hb-btn :disabled="is_saving || !canSave" @click="saveTemplate()">Save Template</hb-btn>
            </template>
            <hb-btn>Save</hb-btn>
        </HbBottomActionBar>

        <HbGlobalNotification
            v-model="errorNotification"
            type="error"
            :description="errorDescription"
        />
        <TemplateForm :is_saving="is_saving"  v-if="showEditForm" title="Manage Template" :selected="template" @save="saveTemplate" @close="closeForm()" />
        <hb-modal
        title="Save changes before closing?"
        v-model="is_cancel_modal_open"
        confirmation
        size="medium"
        :show-help-link="false"
        
    >
        <template v-slot:subheader>
            <div style="height:6vh; padding-top:1.5vh; margin-bottom: 20px; color: black"> You have unsaved changes. If you close now, your changes will be lost. </div>
            
        </template>
        <template v-slot:left-actions>
        </template>
        <template v-slot:right-actions>
            <hb-btn @click="$emit('close')" color="secondary">Close</hb-btn>
            <hb-btn @click="saveTemplate()" color="primary">Save & Close</hb-btn>
        </template>
        </hb-modal>
    </div>
</template>


<script type="text/babel">
import MergeFields from './MergeFields.vue';
import TemplateForm from './TemplateForm.vue';
import Editor from './MceEditor.vue';
import api from '../../../assets/api.js';
 import { mapGetters } from "vuex";
import HbStatus from '../../../aviary/HbStatus.vue';
export default {
    name: "ManageDocumentTemplate",
    data() {
        return {
            errorNotification: false,
            errorDescription: null, 
            showEditForm: false,
            activeTab: 'settings', 
            template: {
                id: null, 
                carboneTemplateId: null, 
                name: '',
                type: '',
                Properties: [],
                template: '',
            },
            preview_content: '',
            template_is_loaded: false, 
            template_is_loading: false, 
            is_cancel_modal_open: false,
            is_saving: false, 
            expansion_panels: 0,
            panel: null, 
            template_types: [
                { text: 'Rent Change', value: 'rent-change' },
                { text: 'Delinquency', value: 'delinquency' },
                { text: 'Maintenance', value: 'maintenance' },
                { text: 'Alerts', value: 'alerts' },
                { text: 'General', value: 'general' },
            ],
            canSave: false,
            is_closing: true
        };
    },
    props: ['data'],
    async created(){
        if(this.$props.data?.id){
            this.template.id = this.$props.data.id;
            this.fetchTemplate();
        } else {
            this.showEditForm = true;
            this.template_is_loaded = false;
            this.template_is_loading = false;
        }
        this.canSave = this.hasPermission('edit_template')
    }, 
    computed:{
        ...mapGetters({
            facilityList: 'propertiesStore/filtered',
            hasPermission: 'authenticationStore/rolePermission'
        }),
        filterPropertyList() {
            return this.facilityList.map(obj => ({ id: obj.id, name: obj.name }));
        },
         isEditDocument(){
            return !!this.template.id
        },
        template_title(){
            if(!this.template.id || !this.template_is_loaded) return "";
            return `${this.template.name} (${this.template.type})`
            
        }
    },
    methods:{
        cancelSave() {
            const is_dirty = this?.$refs?.editor?.isEditorDirty();
            if (!is_dirty || !this.canSave) this.$emit('close')
            else {
                this.is_cancel_modal_open = true;
            }
        },
        closeForm(){
            if(!this.template.id) {
                this.cancelSave()
            }
        }, 
        showPreview(content){

            if(this.panel == 'preview'){
                this.panel = null;
                this.preview_content = null
            } else {
                this.panel = 'preview';
                this.preview_content = content

            }
        }, 

        getProperty(p){
            let property = this.facilityList.find(prop => prop.id === p.id )
            if(!property) return {}
            return property
        }, 


        showMergeFields() {
            this.panel = this.panel == 'merge_fields' ? null : 'merge_fields';
        }, 
        closeMergeFields() {
            this.panel = null;
            this.is_closing = !this.is_closing
        },
        async addMergeField(token){
            this.$refs.editor.insertToken(token)
        }, 
        async getDocumentTypes(){
            try {
                let response = await this.$http.get(api.DOCUMENT + '/types');
                this.template_types = response.body.data.types;
            } catch(err){
                console.log(err)
            }
        },
        getHelpLink() {
            try {
                let helpUrl = "https://help.tenantinc.com/2025/learn-about-document-manager";
                let newTab = window.open();
                newTab.location.href = helpUrl;
            } catch (e) {
                console.error(e)
            }
        },
        async fetchTemplate(){
            try {
                
                this.template.template = {}; 
                this.template_is_loading = true;
                let response = await this.$http.get(api.DOCUMENT + '/' + this.template.id)
                
                this.template.template = response.body.data.template.template || "";
                this.template.template_header = response.body.data.template.template_header || "";
                this.template.template_footer = response.body.data.template.template_footer || "";
                this.template.name = response.body.data.template.name;
                this.template.Properties = response.body.data.template.Properties;
                this.template.type =response.body.data.template.type;
         
            } catch(err){
                console.log(err); 
            }
            this.template_is_loaded = true;
            this.template_is_loading = false;
        }, 

  
        getPreview(){
            
            let html = this.$refs.editor.getContent(); 
     
            this.template.template = html.template;
            this.template.template_header = html.template_header;
            this.template.template_footer = html.template_footer;
            this.template.template_header_height = html.template_header_height;
            this.template.template_footer_height = html.template_footer_height;
            this.template.is_signature = is_signature;

        },
        async saveTemplate(template_data){
            try{
                this.is_saving = true;
                
                let should_exit = false;   
                let data = {};
                if(template_data){
                    // If data is passed in, its coming from the edit details modal. 
                    // Dont update the template html here, since the user isnt expecting that to be saved

                    // if there is no ID and there is a template, then the user has uploaded a docx file
                    if(!template_data.id && template_data.template){
                        data.template = template_data.template || "";
                    } 
                    // data.template_header = this.template.template_header || "";
                    // data.template_footer = this.template.template_footer || "";
                    data.name = template_data.name;
                    data.Properties = template_data.Properties;
                    data.type = template_data.type;

                } else {
                    // else, save the editor content and then exit the editor
                    should_exit = true;

                    let html = this.$refs.editor.getContent(); 

                    this.template.template = html.template;
                    this.template.template_header = html.template_header;
                    this.template.template_footer = html.template_footer;
                    this.template.template_header_height = html.template_header_height;
                    this.template.template_footer_height = html.template_footer_height;

                    data = {
                        template: this.template.template || "",
                        template_header: this.template.template_header || "",
                        template_footer: this.template.template_footer || "",
                        template_header_height: this.template.template_header_height || "",
                        template_footer_height: this.template.template_footer_height || "",
                        name: this.template.name,
                        Properties: this.template.Properties,
                        type: this.template.type,
                    }
                }
                
                if(this.template.id){
                    let response = await this.$http.put(`${api.DOCUMENT}/${this.template.id}`, data)
                } else {

                    let response = await this.$http.post(api.DOCUMENT, data)
                    this.template.id = response.body.data.document_id
                    this.canSave = true
                }
                this.$store.dispatch('documentsStore/setNewTemplate', {
                    level: 'corporate',
                    template: this.template
                    });
                this.fetchTemplate();
                this.$emit('onDocumentsUpdated')
                this.is_saving = false;
                if(should_exit){
                    this.$emit('close')
                }
                this.showEditForm = false;
                
            } catch(err){
                this.errorNotification = true;
                this.errorDescription = err.body.msg;
                console.log("err", err)
            }
            this.is_saving = false;
        }
    }, 
    components:{
        MergeFields,
        Editor,
        TemplateForm,
        HbStatus
    }




}
</script>